import { useState } from 'react';
import { Button, toast, cn } from '@mlm/ui';

/**
 * Icon-only copy-to-clipboard button. Swaps to a check for ~1.6s and fires a
 * toast on success (e.g. copying a tracking number to paste into the courier
 * site). Uses inline SVGs so the merchant app stays free of an icon dependency.
 */
export function CopyButton({
  value,
  label = 'Copied',
  title = 'Copy',
  className,
}: {
  value: string;
  label?: string;
  title?: string;
  className?: string;
}) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      toast.success(label);
      setTimeout(() => setCopied(false), 1600);
    } catch {
      toast.error('Could not copy');
    }
  }

  return (
    <Button
      type="button"
      size="icon"
      variant="ghost"
      onClick={copy}
      title={title}
      aria-label={title}
      className={cn('h-6 w-6 shrink-0 text-muted-foreground hover:text-foreground', className)}
    >
      {copied ? (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="h-3.5 w-3.5"
        >
          <path d="M20 6 9 17l-5-5" />
        </svg>
      ) : (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="h-3.5 w-3.5"
        >
          <rect width="14" height="14" x="8" y="8" rx="2" ry="2" />
          <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
        </svg>
      )}
    </Button>
  );
}
